import MudrexIcon from "../MudrexIcon/MudrexIcon";

interface ErrorStateProps {
  icon?: string;
  iconColor?: string;
  iconSize?: number;
  title: string;
  description?: string;
  fullScreen?: boolean;
  action?: React.ReactNode;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  icon = "Warning",
  iconColor = "#EF4444",
  iconSize = 32,
  title,
  description,
  fullScreen = true,
  action
}) => {
  return (
    <div
      className={`flex items-center justify-center p-4 ${
        fullScreen ? "min-h-screen" : "h-full"
      }`}
    >
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-xl p-6 flex flex-col items-center text-center gap-3">
        {/* Error icon */}
        <MudrexIcon icon={icon} size={iconSize} color={iconColor} />

        {/* Error title */}
        <h3 className="text-base font-semibold text-gray-900 mb-1">{title}</h3>

        {/* Optional description */}
        {description && <p className="text-sm text-gray-600">{description}</p>}

        {/* Optional action button */}
        {action && <div className="w-full mt-2">{action}</div>}
      </div>
    </div>
  );
};

export default ErrorState;
